"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPhoneNumber = exports.formatPhoneAsAvoury = void 0;
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * Formats the given phone number to add spaces and symbols
 * @param {string} - Phone number to be formatted
 * @returns {string}  - Formatted phone number
 */
const formatPhoneNumber = value => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};
exports.formatPhoneNumber = formatPhoneNumber;
const MAXIMUM_LENGTH_PHONE_FIELD = 32;
const PREFIX_MAX_LENGTH = 5;
const formatPhoneAsAvoury = value => {
  if (!value) return '';
  // @ts-ignore
  const phoneNumber = value.replaceAll(/[^\d]/gi, '');
  return `${phoneNumber.slice(0, MAXIMUM_LENGTH_PHONE_FIELD - PREFIX_MAX_LENGTH)}`;
};
exports.formatPhoneAsAvoury = formatPhoneAsAvoury;